import { CalendarEvent } from '@alluradirect/react';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { calendarEvent } from '@alluradirect/react';

const alluraEventSlice = createSlice({
  name: 'alluraEvent',
  initialState: calendarEvent,
  reducers: {
    resetAlluraEvent: () => calendarEvent,
    setAlluraEvent: (_state, { payload: { alluraEvent } }: PayloadAction<{ alluraEvent: CalendarEvent }>) =>
      alluraEvent,
    setTitleAndDescription: (
      state,
      { payload: { title, description } }: PayloadAction<{ title: string; description: string }>,
    ) => {
      state.TITLE = title;
      state.NOTES_OWNER = description;
    },
  },
});

export const {
  reducer: alluraEventReducer,
  actions: { setAlluraEvent, resetAlluraEvent, setTitleAndDescription },
} = alluraEventSlice;
